<template>
    <x-card
        class="risk-type mb-3"
        :class="{ active: active }"
    >
        <x-card-title>
            <x-layout justify-space-between align-center>
                <x-flex>
                    <span data-test="risk-type-title">{{ option.text }}</span>
                </x-flex>

                <x-flex class="text-xs-right grow-0">
                    <x-checkbox
                        v-model="riskFilters"
                        :value="option.value"
                        hide-details
                        class="ma-0 no-label dashboard-checkbox"
                        data-test="risk-type-checkbox"
                    />
                </x-flex>
            </x-layout>
        </x-card-title>

        <x-card-text>
            <span class="number">{{ riskStructureCount(option.value) }}</span>
        </x-card-text>
    </x-card>
</template>

<script>
export default {
    props: ['value', 'option', 'active', 'stats'],
    data() {
        return {
            check: false
        }
    },
    computed: {
        riskFilters: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    methods: {
        change() {
            this.$emit('change')
        },
        riskStructureCount(value) {
            return this.stats[value];
        }
    }
}
</script>

<style lang="scss" scoped>
.risk-type {
    .x-card__text {
        padding-bottom: 0;
    }

    .number {
        color: rgba($color-white, 0.5);
        font-size: rem(32px);
        font-family: $font-title;
    }

    &.active {
        &::before {
            background: $color-secondary;
        }

        .number, .x-card__title {
            color: $color-secondary;
        }
    }
}
</style>
